/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
/* globals duration, elasticEase, paper, imagesLoaded */

import { gsap, Elastic } from 'gsap/all';
import { enableBodyScroll } from 'body-scroll-lock';

class ControlPoint {
    constructor(index, line, path, start, canMove) {
        this.shape = null;
        this.animation = null;
        this.connected = false;
        this.scrollCorrection = 0;
        this.firstScrollReset = true;
        this.index = index;

        const pointShape = new paper.Path.Circle({
            center: [0, 0],
            radius: 0,
            fillColor: 'transparent',
        });

        const pointSymbol = new paper.Symbol(pointShape.rasterize());
        pointShape.remove();

        function randomIntFromInterval(min, max) { // min and max included
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        if (canMove) {
            this.shape = pointSymbol.place(start);
            this.shape.parent = path.parent;
            this.animation = gsap.timeline();

            EventBus.$on('snapTrough', () => {
                // eslint-disable-next-line no-shadow
                const { start } = this;
                const shape = this.shape.position;
                const { point } = this.path.segments[this.index];

                const easePeriod = 0.3;
                const easeStrength = 1;
                const localElasticEase = Elastic.easeOut.config(easeStrength, easePeriod);

                this.animation.clear();
                gsap.to([point, shape], {
                    duration: 3,
                    x: start.x,
                    y: index === 3 ? window.cachedProps.windowHeight / 10 : -30,
                    ease: localElasticEase,
                    delay: randomIntFromInterval(0, 300) / 1000,
                });

                if (index === 3) {
                    EventBus.$emit('header-scroll-down');

                    gsap.delayedCall(1.5, () => {
                        enableBodyScroll(document.querySelector('.header'));
                    });

                    gsap.delayedCall(3.3, () => {
                        EventBus.$emit('header-scroll-down-complete');
                    });
                }
            });

            EventBus.$on('scroll-stopped', () => {
                if (!this.snapping) {
                    this.snapping = true;
                    if (this.index === 3) {
                        EventBus.$emit('snap-back');
                    }
                    this.snapBack();
                }
            });

            EventBus.$on('return-to-video', () => {
                // eslint-disable-next-line no-shadow
                const { start } = this;
                const shape = this.shape.position;
                const { point } = this.path.segments[this.index];
                const easePeriod = 0.6;
                const easeStrength = 1;
                const localElasticEase = Elastic.easeOut.config(easeStrength, easePeriod);

                this.animation.clear();
                if (this.index === 3) {
                    EventBus.$emit('header-scroll-up');
                    document.querySelector('.content').classList.remove('content--scrolled');
                    gsap.to('.--return .project__header-scroll-text', {
                        autoAlpha: 0,
                        duration: 0.5,
                    });
                }

                this.snappingTrough = false;
                gsap.to([point, shape], {
                    duration: 3,
                    x: start.x,
                    y: start.y,
                    ease: localElasticEase,
                    delay: randomIntFromInterval(0, 300) / 1000,
                    onComplete: () => {
                        if (this.index === 3) {
                            gsap.delayedCall(0.3, () => {
                                EventBus.$emit('return-to-video-complete');
                            });
                        }
                    },
                });
            });
        }

        this.line = line;
        this.start = start;
        this.canMove = canMove;
        this.path = path;
        this.snapping = false;
    }

    destroy() {
        // eslint-disable-next-line no-unused-expressions
        this.animation && this.animation.kill();

        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const prop in this) {
            this[prop] = null;
        }
    }

    refresh() {
        const isAnimating = this.animation.isActive();
        const segment = this.path.segments[this.index];
        var close = this.start.isClose(this.shape.position, 0.1);
        const windowOffset = window.cachedProps.windowHeight;

        if (this.snapping) {
            return true;
        }

        if (this.snapAnimation) {
            this.snapAnimation.clear();
        }

        if (window.scrollData && scrollData.y < 0 && this.index === 3) {
            if (this.firstScrollReset) {
                this.scrollCorrection = 0;
                this.firstScrollReset = false;
            }

            // this.animation.clear();
            // var direction = segment.point.subtract(mouse.point).normalize();
            const offset = (scrollData.y + this.scrollCorrection) * 0.2;
            // segment.point.x = xAxisLocked ? segment.point.x :offset.x;
            const dist = yAxisLocked ? segment.point.y : offset + windowOffset;
            // console.log(scrollData);

            if (this.snappingTrough) {
                return true;
            }

            if (dist < (window.cachedProps.windowHeight / 4) * 3) {
                this.snapTrough();
            } else {
                segment.point.y = yAxisLocked ? segment.point.y : offset + windowOffset;
                this.shape.position = segment.point;
            }
        } else if (!isAnimating && !close && !this.snapping) {
            // this.snapBack();
        }

        return isAnimating || !close;

        /* eslint-disable */
        const dist1 = mouse.point.getDistance(segment.point, true);
        var close = this.start.isClose(this.shape.position, 0.1);
        const { start } = this;

        if (dist1 < repelDistSq) {
            console.log('repel');
            this.animation.clear();
            const dist2 = mouse.point.getDistance(start, true);

            if (dist2 > snapDistSq) {
                this.snapBack();
            } else {
                const direction = segment.point.subtract(mouse.point).normalize();
                const offset = direction.multiply(repelDist - 1).add(mouse.point);

                segment.point.x = xAxisLocked ? segment.point.x : offset.x;
                segment.point.y = yAxisLocked ? segment.point.y : offset.y;
                this.shape.position = segment.point;
            }
        } else if (!isAnimating && !close) {
            this.snapBack();
        }
        /* eslint-enable */

        return isAnimating || !close;
    }

    snapTrough() {
        this.snappingTrough = true;
        const { start } = this;
        const shape = this.shape.position;
        const { point } = this.path.segments[this.index];

        this.animation.clear();
        EventBus.$emit('snapTrough');
    }

    snapBack() {
        if (!this.canMove) {
            return;
        }
        const { start } = this;
        const shape = this.shape.position;
        const { point } = this.path.segments[this.index];
        const easePeriod = 0.3;
        const easeStrength = 1;
        const localElasticEase = Elastic.easeOut.config(easeStrength, easePeriod);

        this.animation.clear();
        if (this.snapAnimation) {
            this.snapAnimation.clear();
        }

        this.snapAnimation = gsap.timeline();
        this.snapAnimation.to([point, shape], {
            duration: 3,
            x: start.x,
            y: start.y,
            ease: localElasticEase,
        });

        gsap.delayedCall(1, () => {
            this.snapping = false;
            if (this.index === 3) {
                EventBus.$emit('snap-back-complete');
            }
        });
    }
}

export default ControlPoint;
